import { render } from "./Notification.vue?vue&type=template&id=6d463c6c"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=6d463c6c&lang=scss"

import exportComponent from "C:\\development\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AdminUI\\admin-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__